unable to read source [project]/packages/src/@types/FontTypes.ts